import { create } from "zustand"

import { EnterParentPasscodeType, ParentPasscodeStep } from "../../../../types"

interface ParentPasscodeModalStoreProps {
  isOpen: boolean
  onOpen: (enterType?: EnterParentPasscodeType) => void
  onClose: () => void
  currentPasscode: string
  setCurrentPasscode: (currentPasscode: string) => void
  passcode: string
  setPasscode: (passcode: string) => void
  confirmPasscode: string
  setConfirmPasscode: (confirmPasscode: string) => void
  step: ParentPasscodeStep
  setStep: (step: ParentPasscodeStep) => void
  showError: boolean
  setShowError: (showError: boolean) => void
  enterType: EnterParentPasscodeType
  hasParentAppRequirement: boolean
  setHasParentAppRequirement: (hasParentAppRequirement: boolean) => void
  hasParentPanelRequirement: boolean
  setHasParentPanelRequirement: (hasParentPanelRequirement: boolean) => void
}

export const useParentPasscodeModalStore =
  create<ParentPasscodeModalStoreProps>((set) => ({
    isOpen: false,
    onOpen: (enterType?: EnterParentPasscodeType) => {
      set({ isOpen: true, enterType })
    },
    onClose: () =>
      set({
        isOpen: false,
        step: ParentPasscodeStep.SET_PASSCODE,
        passcode: "",
        confirmPasscode: "",
        currentPasscode: "",
        showError: false,
      }),
    currentPasscode: "",
    setCurrentPasscode: (currentPasscode: string) => set({ currentPasscode }),
    passcode: "",
    setPasscode: (passcode: string) => set({ passcode }),
    confirmPasscode: "",
    setConfirmPasscode: (confirmPasscode: string) => set({ confirmPasscode }),
    step: ParentPasscodeStep.SET_PASSCODE,
    setStep: (step: ParentPasscodeStep) => set({ step }),
    showError: false,
    setShowError: (showError: boolean) => set({ showError }),
    enterType: EnterParentPasscodeType.UPDATE_CODE,
    hasParentAppRequirement: false,
    setHasParentAppRequirement: (hasParentAppRequirement: boolean) =>
      set({ hasParentAppRequirement }),
    hasParentPanelRequirement: false,
    setHasParentPanelRequirement: (hasParentPanelRequirement: boolean) =>
      set({ hasParentPanelRequirement }),
  }))
